import { IObject } from 'interfaces'

export const mockTableWithFrozenFirstColumn = {
  id: '6rj4uzuliymgnyahck25ppvj1',
  type: 'table',
  children: [],
  attributes: {
    name: 'Table',
    fields: [
      {
        type: 'number',
        label: 'number',
        binding: {
          id: '6sjnwm6by5m8fp3mbediwn4jc',
          type: 'binding',
          format: {
            type: 'commas',
            currency: 'usd',
            columnWidth: 'wide',
            shouldFreezeFirstColumn: true,
          },
          source: {
            type: 'field',
            source: {
              type: 'data',
              source: null,
              tableId: 't_9aujyc1yk6rnb8uuy1m037cqr',
              dataType: 'object',
              datasourceId: 'fc93849a0a0f4cbab85ab97ddd4234b5',
            },
            fieldId: 'c_d35ug14yohgb2obq6glonw0ze',
            dataType: 'number',
          },
          bindingType: 'libraryProp',
          childBindings: ['b88pnv9f8156cduv62f1yp4m9'],
          siblingBindings: [],
        },
        fieldId: 'c_d35ug14yohgb2obq6glonw0ze',
      },
      {
        type: 'text',
        label: 'Name',
        binding: {
          id: 'b88pnv9f8156cduv62f1yp4m9',
          type: 'binding',
          format: {
            textLength: 'singleLine',
            columnWidth: 'standard',
          },
          source: {
            type: 'field',
            source: {
              type: 'data',
              source: null,
              tableId: 't_9aujyc1yk6rnb8uuy1m037cqr',
              dataType: 'object',

              datasourceId: 'fc93849a0a0f4cbab85ab97ddd4234b5',
            },
            fieldId: 'c_e72xwttcmzuogc063a0ys9s34',
            dataType: 'text',
          },
          bindingType: 'libraryProp',
          childBindings: [],
          siblingBindings: ['6sjnwm6by5m8fp3mbediwn4jc'],
        },
        fieldId: 'c_e72xwttcmzuogc063a0ys9s34',
      },
    ],
  },
  dataBinding: {
    id: '3hp7hs2cr2hxrrc99btx1h95d',
    type: 'binding',
    source: {
      sort: null,
      type: 'data',
      source: null,
      tableId: 't_9aujyc1yk6rnb8uuy1m037cqr',
      dataType: 'list',
      datasourceId: 'fc93849a0a0f4cbab85ab97ddd4234b5',
    },

    bindingType: 'list',
    childBindings: ['6sjnwm6by5m8fp3mbediwn4jc', 'b88pnv9f8156cduv62f1yp4m9'],
    siblingBindings: [],
  },
} as unknown as IObject

export const mockTableWithNotFrozenFirstColumn = {
  id: '6rj4uzuliymgnyahck25ppvj1',
  type: 'table',
  children: [],
  attributes: {
    name: 'Table',
    fields: [
      {
        type: 'number',
        label: 'number',
        binding: {
          id: '6sjnwm6by5m8fp3mbediwn4jc',
          type: 'binding',
          format: {
            type: 'commas',
            currency: 'usd',
            columnWidth: 'wide',
          },
          source: {
            type: 'field',
            source: {
              type: 'data',
              source: null,
              tableId: 't_9aujyc1yk6rnb8uuy1m037cqr',
              dataType: 'object',
              datasourceId: 'fc93849a0a0f4cbab85ab97ddd4234b5',
            },
            fieldId: 'c_d35ug14yohgb2obq6glonw0ze',
            dataType: 'number',
          },
          bindingType: 'libraryProp',
          childBindings: ['b88pnv9f8156cduv62f1yp4m9'],
          siblingBindings: [],
        },
        fieldId: 'c_d35ug14yohgb2obq6glonw0ze',
      },
      {
        type: 'text',
        label: 'Name',
        binding: {
          id: 'b88pnv9f8156cduv62f1yp4m9',
          type: 'binding',
          format: {
            textLength: 'singleLine',
            columnWidth: 'standard',
          },
          source: {
            type: 'field',
            source: {
              type: 'data',
              source: null,
              tableId: 't_9aujyc1yk6rnb8uuy1m037cqr',
              dataType: 'object',

              datasourceId: 'fc93849a0a0f4cbab85ab97ddd4234b5',
            },
            fieldId: 'c_e72xwttcmzuogc063a0ys9s34',
            dataType: 'text',
          },
          bindingType: 'libraryProp',
          childBindings: [],
          siblingBindings: ['6sjnwm6by5m8fp3mbediwn4jc'],
        },
        fieldId: 'c_e72xwttcmzuogc063a0ys9s34',
      },
    ],
  },
  dataBinding: {
    id: '3hp7hs2cr2hxrrc99btx1h95d',
    type: 'binding',
    source: {
      sort: null,
      type: 'data',
      source: null,
      tableId: 't_9aujyc1yk6rnb8uuy1m037cqr',
      dataType: 'list',
      datasourceId: 'fc93849a0a0f4cbab85ab97ddd4234b5',
    },

    bindingType: 'list',
    childBindings: ['6sjnwm6by5m8fp3mbediwn4jc', 'b88pnv9f8156cduv62f1yp4m9'],
    siblingBindings: [],
  },
} as unknown as IObject
